export default {"src":"/_next/static/media/TrustFinal.b32e8a5e.svg","height":66,"width":108,"blurWidth":0,"blurHeight":0};